export default "__VITE_ASSET__DYgyPO50__"